import { Module } from 'vuex-smart-module';
import ClientDetailActions from './actions';
import ClientDetailGetters from './getters';
import ClientDetailMutations from './mutations';
import ClientDetailState from './state';

export default new Module({
  state: ClientDetailState,
  mutations: ClientDetailMutations,
  actions: ClientDetailActions,
  getters: ClientDetailGetters,
});
